import React from "react";
import { IconProps } from "../icon";

export const SpacingWidth_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 12h12M6 12l2-3m-2 3l2 3m10-3l-2-3m2 3l-2 3m5 6V3M3 21V3"
    />
  </svg>
);
